/* istanbul ignore file */
export default [
  {
    path: '/a2e/scores',
    name: 'a2eScores',
    component: () => import('../views/A2eScores'),
    meta: {
      auth: true
    }
  },
  {
    path: '/ia/scores',
    name: 'scoresOverview',
    component: () => import('../views/Scores'),
    meta: {
      auth: true
    }
  },
  {
    path: '/ia/scores/quartiles',
    name: 'scoresQuartiles',
    component: () => import('../views/Quartiles'),
    meta: {
      auth: true,
      anyCan: { quartile: 'read' }
    }
  },
  {
    path: '/ia/scores/rescore',
    name: 'assessmentRescore',
    component: () => import('../views/AssessmentRescore'),
    meta: {
      auth: true,
      anyCan: { scoringModel: 'write' }
    }
  },
  {
    path: '/ia/scores/model',
    name: 'scoringModel',
    component: () => import('../views/ScoringModel'),
    meta: {
      auth: true,
      anyCan: { score: 'write' }
    }
  }
]
